import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})


export class VendorSettingService {
    private baseURL: string;
    constructor(private http: HttpClient) {
      this.baseURL = environment.apiBaseUrl;
    }

    getVendorGeneralSettings(): Observable<boolean> {
        return this.http.get<any>(
            `${this.baseURL}/VendorSettings/GetVendorGeneralSettings`,
            { observe: 'response' })
            .pipe(
              map(res => {
                const generalSettings = res.body as any;
                return generalSettings;
              }),
              catchError(this.handleError)
            );
       }

       getCurrentMarketVendorGeneralSettings(): Observable<boolean> {
        return this.http.get<any>(
            `${this.baseURL}/VendorSettings/getCurrentMarketVendorGeneralSettings`,
            { observe: 'response' })
            .pipe(
              map(res => {
                const generalSettings = res.body as any;
                return generalSettings;
              }),
              catchError(this.handleError)
            );
       }
       
       getVendorNameFormats(): Observable<boolean> {
        return this.http.get<any>(
            `${this.baseURL}/General/GetVendorNameFormats`,
            { observe: 'response' })
            .pipe(
              map(res => {
                const formats = res.body as any;
                return formats;
              }),
              catchError(this.handleError)
            );
       }
    
       saveVendorGeneralSetting(vendorSettings): Observable<any> {
            const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
            const url = `${this.baseURL}/VendorSettings/SaveVendorGeneralSetting`;
            return this.http.post<any>(url, vendorSettings, options)
                .pipe(
                    map(res => {
                        const response = res as any;
                        return response;
                    }),
                    catchError(this.handleError)
                );
        } 
        
        getVendorRentalSettings(): Observable<any> {
          return this.http.get<any>(
              `${this.baseURL}/VendorSettings/GetVendorRentalSettings`,
              { observe: 'response' }
            )
            .pipe(
              map(res => res.body as any),
              catchError(this.handleError)
            );
        }
        
        saveVendorRentalSetting(vendorRentalSettings: any): Observable<any> {
          const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
          const url = `${this.baseURL}/VendorSettings/SaveVendorRentalSetting`;
          return this.http.post<any>(url, vendorRentalSettings, options)
            .pipe(
              map(res => res as any),
              catchError(this.handleError)
            );
        }
        
        private handleError(error: HttpErrorResponse) {
          console.error('server error:', error);
          if (error.error instanceof Error) {
              const errMessage = error.error.message;
              return throwError(errMessage);
          }
          return throwError(error || 'Node.js server error');
      }
}
  